/* Rashu 2026 theme script: overlays, tabs, vestiaire, AJAX cart, predictive search, product form, size tape.
   No dependency, loaded with defer. */
(function () {
  "use strict";
  var R = window.RASHU || { routes: {}, t: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (R.routes.root || "/").replace(/\/?$/, "/");

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(".", ",").replace(/,00$/, "");
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €";
  }

  /* ---------- overlays ---------- */
  var lastFocus = null;
  function open(id) {
    var el = document.getElementById(id); if (!el) return false;
    $$(".drawer.is-open,.modal.is-open").forEach(function (x) { if (x !== el) close(x, true); });
    lastFocus = document.activeElement;
    el.classList.add("is-open"); el.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var fo = el.querySelector("input:not([type=hidden]),button[data-close],button");
    if (fo) setTimeout(function () { fo.focus(); }, 60);
    return true;
  }
  function close(el, silent) {
    el.classList.remove("is-open"); el.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  R.open = open;
  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-open]");
    if (o) {
      if (open(o.getAttribute("data-open"))) e.preventDefault();
      return;
    }
    var cl = e.target.closest("[data-close]");
    if (cl) { var l = cl.closest(".drawer,.modal"); if (l) close(l); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") $$(".drawer.is-open,.modal.is-open").forEach(function (x) { close(x); });
    if (e.key === "Tab") {
      var box = $(".drawer.is-open .drawer__panel,.modal.is-open .modal__box"); if (!box) return;
      var f = $$("a[href],button:not([disabled]),input:not([type=hidden]),select,textarea", box).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* tabs (mobile menu) */
  document.addEventListener("click", function (e) {
    var t = e.target.closest(".tab[data-tab]"); if (!t) return;
    $$(".tab[data-tab]", t.parentNode).forEach(function (x) {
      x.setAttribute("aria-selected", x === t ? "true" : "false");
      var p = document.getElementById(x.getAttribute("data-tab")); if (p) p.hidden = x !== t;
    });
  });
  /* mega-menu on touch screens: first tap opens */
  $$(".nav__item").forEach(function (it) {
    var a = it.querySelector(".nav__link");
    a.addEventListener("touchend", function (e) {
      if (!it.classList.contains("is-open")) {
        e.preventDefault();
        $$(".nav__item.is-open").forEach(function (n) { n.classList.remove("is-open"); });
        it.classList.add("is-open");
      }
    });
  });
  document.addEventListener("touchstart", function (e) {
    if (!e.target.closest(".nav__item")) $$(".nav__item.is-open").forEach(function (n) { n.classList.remove("is-open"); });
  }, { passive: true });

  /* ---------- vestiaire (wishlist without account) ---------- */
  var KF = "rashu-vestiaire", favs = [];
  try { favs = JSON.parse(localStorage.getItem(KF) || "[]"); } catch (e) { favs = []; }
  function paintFavs() {
    $$("[data-fav]").forEach(function (b) { b.setAttribute("aria-pressed", favs.indexOf(b.getAttribute("data-fav")) > -1 ? "true" : "false"); });
    $$("[data-fav-count]").forEach(function (x) { x.textContent = favs.length; x.hidden = !favs.length; });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-fav]"); if (!b) return;
    e.preventDefault();
    var id = b.getAttribute("data-fav"), i = favs.indexOf(id);
    if (i > -1) favs.splice(i, 1); else favs.push(id);
    try { localStorage.setItem(KF, JSON.stringify(favs)); } catch (er) {}
    paintFavs();
    if (b.hasAttribute("data-fav-remove")) { var c = b.closest(".card"); if (c) c.remove(); }
  });
  paintFavs();

  /* wishlist page */
  var wl = $("[data-wishlist]");
  if (wl) {
    var empty = $("[data-wishlist-empty]");
    if (!favs.length) { if (empty) empty.hidden = false; }
    else {
      Promise.all(favs.map(function (h) {
        return fetch(root + "products/" + encodeURIComponent(h) + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (list) {
        list = list.filter(Boolean);
        if (!list.length && empty) { empty.hidden = false; return; }
        wl.innerHTML = list.map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_600x$1$2") : "";
          return '<article class="card"><a class="card__img card__img--photo" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, "&quot;") + '" width="600" height="600" loading="lazy">' : "") + "</a>" +
            '<button class="card__fav" type="button" data-fav="' + p.handle + '" data-fav-remove aria-pressed="true" aria-label="Retirer">' + ($(".card__fav svg") ? $(".card__fav svg").outerHTML : "") + "</button>" +
            '<div class="card__txt"><h3><a href="' + p.url + '">' + p.title + '</a></h3><span class="price">' + (p.price_varies ? "<small>dès </small>" : "") + money(p.price) + "</span></div></article>";
        }).join("");
        paintFavs();
      });
    }
  }

  /* ---------- AJAX cart ---------- */
  function paintCount(n) { $$("[data-cart-count]").forEach(function (x) { x.textContent = n; }); }
  function refreshDrawer(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var np = doc.querySelector("#cart .drawer__panel"), op = $("#cart .drawer__panel");
    if (np && op) op.innerHTML = np.innerHTML;
  }
  function cartRequest(url, body) {
    body.sections = "cart-drawer";
    body.sections_url = window.location.pathname;
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function afterCart(j) {
    if (j.sections && j.sections["cart-drawer"]) refreshDrawer(j.sections["cart-drawer"]);
    return fetch(root + "cart.js").then(function (r) { return r.json(); }).then(function (c) { paintCount(c.item_count); return c; });
  }
  function addToCart(id, qty, btn, msg) {
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
    return cartRequest(R.routes.cartAdd + ".js", { items: [{ id: +id, quantity: qty || 1 }] })
      .then(afterCart)
      .then(function () { if (msg) { msg.textContent = R.t.added || ""; msg.classList.remove("err"); } open("cart"); })
      .catch(function (err) { if (msg) { msg.textContent = (err && (err.description || err.message)) || R.t.error; msg.classList.add("err"); } else { alert((err && err.description) || R.t.error); } })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); } });
  }
  R.addToCart = addToCart;
  /* card quick add: size panel opened by tap on touch screens, option tabs (Manches) switch the size row */
  function qaClose(card) {
    if (!card) return;
    card.classList.remove("is-qa-open");
    var b = card.querySelector("[data-qa-open]"); if (b) b.setAttribute("aria-expanded", "false");
  }
  function qaCloseAll(except) { $$(".card.is-qa-open").forEach(function (c) { if (c !== except) qaClose(c); }); }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { var c = $(".card.is-qa-open"); if (c) { qaClose(c); var b = c.querySelector("[data-qa-open]"); if (b) b.focus(); } }
  });
  document.addEventListener("click", function (e) {
    var qo = e.target.closest("[data-qa-open]");
    if (qo) {
      e.preventDefault();
      var card = qo.closest(".card");
      qaCloseAll(card);
      card.classList.add("is-qa-open"); qo.setAttribute("aria-expanded", "true");
      var first = card.querySelector(".card__qa-list:not([hidden]) [data-quick], .card__qa-tab, .card__qa-more");
      if (first) first.focus({ preventScroll: true });
      return;
    }
    var qc = e.target.closest("[data-qa-close]");
    if (qc) { e.preventDefault(); var cc = qc.closest(".card"); qaClose(cc); var ob = cc && cc.querySelector("[data-qa-open]"); if (ob) ob.focus({ preventScroll: true }); return; }
    var qt = e.target.closest("[data-qa-tab]");
    if (qt) {
      e.preventDefault();
      var box = qt.closest(".card__qa-panel"), i = qt.getAttribute("data-qa-tab");
      $$("[data-qa-tab]", box).forEach(function (t) { t.setAttribute("aria-pressed", t === qt ? "true" : "false"); });
      $$("[data-qa-group]", box).forEach(function (g) { g.hidden = g.getAttribute("data-qa-group") !== i; });
      return;
    }
    if (!e.target.closest(".card__qa")) qaCloseAll(null);
    var q = e.target.closest("[data-quick]");
    if (q) {
      e.preventDefault();
      var qcard = q.closest(".card");
      addToCart(q.getAttribute("data-quick"), 1, q).then(function () { qaClose(qcard); });
      return;
    }
    var l = e.target.closest("[data-line-key]");
    if (l) {
      e.preventDefault();
      l.disabled = true;
      cartRequest(R.routes.cartChange + ".js", { id: l.getAttribute("data-line-key"), quantity: +l.getAttribute("data-line-qty") })
        .then(afterCart).then(function () { if (document.body.classList.contains("tpl-cart")) window.location.reload(); })
        .catch(function () { l.disabled = false; });
    }
  });

  /* collection photo view (Romain 25/10): « Porté » (worn photo, default) or « Produit seul » (garment on the hanger).
     The class is set in <head> before paint (layout/theme.liquid), so there is no jump; here we only sync and store. */
  var KV = "rashu-vue";
  function paintView() {
    var flat = document.documentElement.classList.contains("view-flat");
    $$("[data-view]").forEach(function (b) { b.setAttribute("aria-pressed", (b.getAttribute("data-view") === "flat") === flat ? "true" : "false"); });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-view]"); if (!b) return;
    var flat = b.getAttribute("data-view") === "flat";
    document.documentElement.classList.toggle("view-flat", flat);
    try { localStorage.setItem(KV, flat ? "flat" : "worn"); } catch (er) {}
    paintView();
  });
  paintView();

  /* ---------- predictive search ---------- */
  var pin = $("[data-predict-input]"), pout = $("[data-predict-results]"), ptimer = null;
  if (pin && pout && R.routes.search) {
    pin.addEventListener("input", function () {
      clearTimeout(ptimer);
      var v = pin.value.trim();
      if (v.length < 2) { pout.innerHTML = ""; return; }
      ptimer = setTimeout(function () {
        fetch(R.routes.search + ".json?q=" + encodeURIComponent(v) + "&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last")
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var res = (j.resources && j.resources.results) || {}, h = "";
            (res.collections || []).slice(0, 3).forEach(function (c) { h += '<a href="' + c.url + '"><span></span><b>' + c.title + "</b><span class=\"small\">Collection</span></a>"; });
            (res.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf("?") > -1 ? "&" : "?") + "width=120" : "";
              h += '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="56" height="64" loading="lazy">' : "<span></span>") + "<b>" + p.title + '</b><span class="price">' + money(Math.round(parseFloat(p.price) * 100)) + "</span></a>";
            });
            (res.articles || []).slice(0, 2).forEach(function (a) { h += '<a href="' + a.url + '"><span></span><b>' + a.title + '</b><span class="small">Shiai</span></a>'; });
            (res.pages || []).slice(0, 2).forEach(function (a) { h += '<a href="' + a.url + '"><span></span><b>' + a.title + '</b><span class="small">Page</span></a>'; });
            pout.innerHTML = h || "<p>" + (R.t.noResults || "") + "</p>";
          }).catch(function () { pout.innerHTML = ""; });
      }, 220);
    });
  }

  /* ---------- product form ---------- */
  var pf = $("[data-product-form]");
  if (pf) {
    var variants = [];
    try { variants = JSON.parse($("[data-variants]").textContent); } catch (e) {}
    var idInput = $("input[name=id]", pf), addBtn = $("[data-add]", pf), msg = $("[data-product-msg]");
    var stBtn = $("[data-sticky-add]"), stOpt = $("[data-sticky-opt]");
    var chosen = idInput && idInput.value ? +idInput.value : null;
    /* one picker per option (Manches, Taille): sel[i] = picked value of option i, the variant follows */
    var groups = $$("[data-opt]", pf), sel = groups.map(function (g) {
      var on = $("[data-opt-i][aria-pressed=true]", g); return on ? on.getAttribute("data-value") : null;
    });
    function match(v, upto) { for (var j = 0; j < upto; j++) { if (sel[j] !== null && v.options[j] !== sel[j]) return false; } return true; }
    function refresh() {
      groups.forEach(function (g, i) {
        $$("[data-opt-i]", g).forEach(function (b) {
          var val = b.getAttribute("data-value");
          var ok = variants.some(function (v) { return v.available && v.options[i] === val && match(v, i); });
          b.disabled = !ok; b.classList.toggle("is-out", !ok);
          if (ok) b.removeAttribute("aria-label"); else b.setAttribute("aria-label", val + ", " + (R.t.soldOut || "épuisé"));
          if (!ok && sel[i] === val && groups.length > 1 && i === groups.length - 1) { sel[i] = null; b.setAttribute("aria-pressed", "false"); }
        });
        var lb = $("[data-opt-label]", g); if (lb) lb.textContent = sel[i] !== null ? sel[i] : (R.t.choose || "choisir");
      });
      var v = sel.indexOf(null) === -1 ? variants.filter(function (x) { return match(x, sel.length); })[0] : null;
      chosen = v ? v.id : null;
      if (idInput) idInput.value = chosen || "";
      /* price follows the sleeve length even before the size is picked */
      var pv = v || variants.filter(function (x) { return match(x, sel.length); })[0];
      var pr = $("[data-price]"); if (pr && pv) pr.textContent = money(pv.price);
      if (stOpt) stOpt.textContent = v ? groups.map(function (g, i) { return $$("[data-opt-i]", g).length > 1 || groups.length === 1 ? sel[i] : null; }).filter(Boolean).join(" / ") : R.t.chooseSize;
      return v;
    }
    function pick(btn) {
      var i = +btn.getAttribute("data-opt-i");
      sel[i] = btn.getAttribute("data-value");
      $$("[data-opt-i]", groups[i]).forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
      var v = refresh();
      if (msg) { msg.textContent = ""; msg.classList.remove("err"); }
      if (v && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set("variant", v.id); window.history.replaceState({}, "", u.toString());
      }
    }
    if (groups.length) refresh();
    pf.addEventListener("click", function (e) { var b = e.target.closest("[data-opt-i]"); if (b && !b.disabled) pick(b); });
    function submit(btn) {
      if (!chosen) {
        if (msg) { msg.textContent = R.t.chooseSize; msg.classList.add("err"); }
        var first = $(".opt__row--size [data-opt-i]:not([disabled])", pf) || $("[data-opt-i]:not([disabled])", pf); if (first) first.focus();
        return;
      }
      addToCart(chosen, 1, btn, msg);
    }
    pf.addEventListener("submit", function (e) { e.preventDefault(); submit(addBtn); });
    if (stBtn) stBtn.addEventListener("click", function () { if (!chosen) { pf.scrollIntoView({ behavior: "smooth", block: "center" }); } submit(stBtn); });
    /* sticky bar appears once the buy button leaves the screen */
    var sticky = $("#sticky");
    if (sticky && addBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle("on", !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
    }
    /* gallery */
    $$("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        var img = $("#stageimg"); if (!img) return;
        img.src = t.getAttribute("data-src"); img.srcset = t.getAttribute("data-srcset") || ""; img.alt = t.getAttribute("data-alt") || "";
        $$("[data-thumb]").forEach(function (x) { x.setAttribute("aria-pressed", x === t ? "true" : "false"); });
      });
    });
  }

  /* ---------- product gallery: mobile counter + dots, zoom with prev/next ---------- */
  var gal = $("[data-gal]");
  if (gal) {
    var track = $("[data-gal-track]", gal), gi = $("[data-gal-i]", gal), dots = $$(".gal__dots span", gal);
    var srcs = []; try { srcs = JSON.parse($("[data-gal-src]", gal).textContent); } catch (e) {}
    if (track && gi) {
      var tick = null;
      track.addEventListener("scroll", function () {
        cancelAnimationFrame(tick);
        tick = requestAnimationFrame(function () {
          var it = track.children[1] || track.children[0], step = it ? it.offsetLeft - track.children[0].offsetLeft : track.clientWidth;
          var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(1, step || track.clientWidth)));
          gi.textContent = i + 1;
          dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
        });
      }, { passive: true });
    }
    var zi = $("[data-zoom-img]"), zcur = 0;
    function zshow(i) { if (!zi || !srcs.length) return; zcur = (i + srcs.length) % srcs.length; zi.src = srcs[zcur]; }
    gal.addEventListener("click", function (e) {
      var b = e.target.closest("[data-zoom]"); if (!b) return;
      zshow(+b.getAttribute("data-zoom")); open("zoom");
    });
    document.addEventListener("click", function (e) { var s = e.target.closest("[data-zoom-step]"); if (s) zshow(zcur + +s.getAttribute("data-zoom-step")); });
    document.addEventListener("keydown", function (e) {
      var z = $("#zoom"); if (!z || !z.classList.contains("is-open")) return;
      if (e.key === "ArrowRight") zshow(zcur + 1); if (e.key === "ArrowLeft") zshow(zcur - 1);
    });
  }
  /* "Compléter la tenue": add the size picked in the row */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-outfit-add]"); if (!b) return;
    var s = b.parentNode.querySelector("[data-outfit-size]");
    if (!s || !s.value) { if (s) { s.classList.add("err"); s.focus(); } return; }
    s.classList.remove("err"); addToCart(s.value, 1, b);
  });

  /* ---------- size tape (home) ---------- */
  var tape = $("#tour");
  if (tape) {
    var SIZES = [["XS", 92], ["S", 96], ["M", 100], ["L", 108], ["XL", 116], ["2XL", 124], ["3XL", 132]], use = "train";
    var size = function () {
      var v = +tape.value, i = 0;
      while (i < SIZES.length - 1 && v > SIZES[i][1]) i++;
      if (use === "train" && i < SIZES.length - 1) i++;
      $("#rsize").textContent = SIZES[i][0];
      $("#rtxt").textContent = v + " cm de tour de poitrine, " + (use === "train" ? "pour l'entraînement" : "pour la compétition");
      $("#rcur").style.left = ((v - 85) / 50 * 100) + "%";
    };
    tape.addEventListener("input", size);
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-use]"); if (!b) return;
      use = b.getAttribute("data-use");
      $$("[data-use]").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      size();
    });
    size();
  }

  /* ---------- collection: sort and filters submit on change ---------- */
  // Filter forms: drop empty fields (empty price bounds) so the URL stays clean.
  $$("form.side").forEach(function (f) {
    f.addEventListener("submit", function () { $$("input[type=number]", f).forEach(function (i) { if (!i.value) i.disabled = true; }); });
  });
  $$("[data-autosubmit]").forEach(function (f) {
    f.addEventListener("change", function (e) { if (e.target.matches("input[type=checkbox],select")) f.requestSubmit ? f.requestSubmit() : f.submit(); });
  });
  $$("[data-sort]").forEach(function (s) {
    s.addEventListener("change", function () { var u = new URL(window.location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); window.location.href = u.toString(); });
  });
})();
